import React, { useState } from "react";
import { createStripeAccount } from "../../../../services/StripeServices";
import globalStyles from "../../../../styles/globalStyles.module.css";
import { useTranslation } from "react-i18next";
import LoadingIcon from "../../../CssIcon/Loading/LoadingIcon";
import { useAlert } from "../../../../context/AlertProvider";

const CreateAccount: React.FC = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const { showAlert } = useAlert();

  const handleCreateStripeAccount = async () => {
    setLoading(true);
    try {
      const json = await createStripeAccount();
      const { url } = json;
      if (url) {
        window.open(url, "_blank");
      }
    } catch (error) {
      if (error) {
        showAlert(t("alert.tryAgain"));
      }
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      {loading && <LoadingIcon />}

      <button
        onClick={handleCreateStripeAccount}
        className={globalStyles.button}
      >
        {t("stripe.createAccount")}
      </button>
    </>
  );
};

export default CreateAccount;
